import WrapUp from './WrapUp';
import ConfidenceRanking from './ConfidenceRanking';

export default {
  title: 'Reflect',
  children: [
    WrapUp,
    ConfidenceRanking
  ]
};



// WEBPACK FOOTER //
// ./src/data/reflect/index.js